import { motion, useReducedMotion } from "framer-motion";

/**
 * Slow editorial marquee. Loops a row of items at a sedate pace.
 * Items can be strings or nodes; separated by a diamond glyph.
 */
export default function Marquee({ items, speed = 55, className = "" }) {
  const reduce = useReducedMotion();
  const content = (
    <div className="flex items-center gap-14 pr-14 whitespace-nowrap">
      {items.map((it, i) => (
        <span key={i} className="inline-flex items-center gap-14">
          <span className="font-display text-[clamp(32px,5vw,88px)] leading-none tracking-[-0.02em]">
            {it}
          </span>
          <span className="text-mango text-3xl" aria-hidden="true">◆</span>
        </span>
      ))}
    </div>
  );

  if (reduce) {
    return <div className={`overflow-hidden ${className}`}>{content}</div>;
  }

  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <motion.div
        className="flex"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ ease: "linear", duration: speed, repeat: Infinity }}
      >
        {content}
        {content}
      </motion.div>
    </div>
  );
}
